import { Injectable } from '@angular/core';
import { TWX_SLUGS } from '@twinnyx/twinnyx.slugs';

/**
 * Where a logged-in user lands. Kept as a service (and not inlined) because the auth pieces
 * brought over from twinny-app (auth service, auth-pages guard, not-found page) ask it for
 * the home; in twinny-app it decided between Twinny and TwinnyX, here it is always TwinnyX.
 */
@Injectable({ providedIn: 'root' })
export class ProductService {
    /** Without a leading slash, like `environment.front.home`. */
    homeUrl(): string {
        return TWX_SLUGS.home;
    }
}
